import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// styles
import styles from "./SearchBarNew.module.scss";

// components
import { SearchInput } from "components/LibraryComponents/Components";
import { Button } from "components/LibraryComponents/Components";

// store
import useFiltersStore from "store/useFiltersStoreNew";

// constant
import { FilterKeys } from "constants/filters";

export default function SearchBarNew() {
  const { searchProfiles, setFilter, clearFilters } = useFiltersStore((state) => ({
    searchProfiles: state.filters.searchProfiles,
    setFilter: state.setFilter,
    clearFilters: state.clearFilters,
  }));

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [value, setValue] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => { // set search input value if user is in advanced search and enters search term from home
    if (pathname.includes("/advanced")) {
      setValue(searchProfiles.searchTerm);
    }
  }, [pathname, searchProfiles]);

  // const pattern = /^[0-9]{1,10}$/; // pattern to check the entity_detail_id

  const handleSearch = async () => {
    setIsLoading(true);
    const trimValue = value.trim();

    if (trimValue !== "") { // check if value is not empty
      // if (pathname === "/") { // if on the homepage
      //   if (pattern.test(trimValue)) {
      //     const isValid = await isValidId(trimValue);

      //     if (isValid) {
      //       setFilter(FilterKeys.ENTITY_DETAIL_ID, trimValue);
      //       navigate(`/profile/${trimValue}`);

      //     } else {
      //       setSearchTerm(trimValue);
      //       navigate("/advanced");
      //     }
      //   }
      //   else {
      //     setSearchTerm(trimValue);
      //     navigate("/advanced");
      //   }
      // } else {
        setSearchTerm(trimValue);
        navigate("/advanced");
      // }
    } else {
      if (searchProfiles.searchTerm.length > 0) { // if value is empty and search term is not empty, clear search term
        setFilter(FilterKeys.SEARCH_TERM, {
          ...searchProfiles,
          searchTerm: "",
        });
      }
    }
    setIsLoading(false);
  }

  const handleOnBlur = async (event: React.FocusEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const trimValue = value.trim();
    
    if (trimValue !== "") {
        setSearchTerm(trimValue);
    }
  }

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    handleSearch();
  }

  const handleEnter = async (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Enter") { // handle enter key
      handleSearch()
    }
  };

  async function isValidId(id) {

    try {
      const response = await fetch(`/_api/v2/profile/${id}`)

      if (!response.ok) {
        throw new Error("Failed to fetch profile data");
      }

      return true
    } catch (error) {
      console.error("Error fetching meili profile results: ", error);
      return false
    }
  };

  const setSearchTerm = (value: string) => {
    setFilter(FilterKeys.SEARCH_TERM, {
      ...searchProfiles,
      searchTerm: value,
    });
  };

  return (
    <>
      <div className={styles["search-bar-root"]}>
        <SearchInput
          id="search-input"
          name="search-input"
          placeholder="Search by name, UEI, CAGE code, narrative, or keywords"
          aria-labelledby="search-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          handleClear={() => {
            setFilter(FilterKeys.SEARCH_TERM, {
              ...searchProfiles,
              searchTerm: "",
            });
            setValue("");
          }}
          onKeyDown={handleEnter}
          disabled={isLoading}
          isLoading={isLoading}
          onBlur={handleOnBlur}
        />
        {pathname === "/" && (
          <Button 
            type="button"
            className={styles["quick-search-button"]}
            onClick={handleClick}
            >Quick Search</Button>
        )}
      </div>
    </>
  );
}
